import React from 'react';
import './Card.css';

const Card = ({ title, label = 'module_01', description, highlights = [], techStack, githubLink, demoLink, image }) => {
  return (
    <article className="card">
      <div className="card-image">
        {image ? (
          <img src={image} alt={title} />
        ) : (
          <div className="card-placeholder">
            <span className="card-terminal-label">pipeline://active</span>
            <strong>{label}</strong>
            <span className="terminal-line"></span>
          </div>
        )}
      </div>
      <div className="card-content">
        <h3 className="card-title">{title}</h3>
        <p className="card-description">{description}</p>
        {highlights.length > 0 && (
          <ul className="card-highlights">
            {highlights.map((highlight) => (
              <li key={highlight}>{highlight}</li>
            ))}
          </ul>
        )}
        <div className="card-tech">
          {techStack.map((tech, index) => (
            <span key={index} className="tech-tag">{tech}</span>
          ))}
        </div>
        {(githubLink || demoLink) && (
          <div className="card-links">
            {githubLink && (
            <a 
              href={githubLink} 
              target="_blank" 
              rel="noopener noreferrer"
              className="card-link github"
            >
              Repository <span aria-hidden="true">-&gt;</span>
            </a>
            )}
            {demoLink && (
              <a
                href={demoLink}
                target="_blank"
                rel="noopener noreferrer"
                className="card-link demo"
              >
                Live Demo <span aria-hidden="true">-&gt;</span>
              </a>
            )}
          </div>
        )}
      </div>
    </article>
  );
};

export default Card;
